<template>
  <div>
    <h1 class="mark-title">保存的标记</h1>
    <p class="no-record" v-if="cookieData == ''">还没有保存任何标记</p>
    <div class="mark">
      <div class="main">
        <div class="mark-list">
          <div
            class="mark-item"
            v-for="(item, index) in cookieData"
            :key="index"
            @touchstart="touchStart($event, index)"
            @touchmove="touchMove($event, index)"
            @touchend="touchEnd($event, item.name, index)"
          >
            <div
              class="mark-item-content"
              v-if="item.type == 'one'"
              id="itemContent"
              :ref="'del' + index"
            >
              <div class="icon">
                <span></span>
              </div>
              <div class="item-wrap">
                <p class="share-type">单点共享</p>
                <p class="remarks">备注：{{ item.info }}</p>
                <p class="agreed-place">约定地点：{{ item.address }}</p>
                <p class="agreed-time">约定时间：{{ item.time }}</p>
              </div>
              <button class="address-copy"></button>
            </div>

            <div class="mark-item-content" v-if="item.type == 'points'">
              <div class="icon">
                <span style="font-size: 22px"></span>
              </div>
              <div class="item-wrap">
                <p class="share-type">地理位置共享</p>
                <p class="remarks">备注：{{ item.info }}</p>
                <p class="agreed-place">约定地点：{{ item.address }}</p>
                <p class="agreed-time">约定时间：{{ item.time }}</p>
              </div>
              <button class="address-copy"></button>
            </div>

            <div class="mark-item-content" v-if="item.type == 'map'">
              <div class="icon">
                <span style="font-size: 22px"></span>
              </div>
              <div class="item-wrap">
                <p class="share-type univ">地图共享</p>
                <p class="remarks">备注：{{ item.info }}</p>
                <p class="agreed-time">约定时间：{{ item.time }}</p>
              </div>
              <button class="address-copy"></button>
            </div>

            <div class="mark-item-content" v-if="item.type == 'road'">
              <div class="icon">
                <span style="font-size: 22px"></span>
              </div>
              <div class="item-wrap">
                <p class="share-type">路段共享</p>
                <p class="remarks">备注：{{ item.info }}</p>
                <p class="road-info">
                  从<span>东职南门</span>到<span>理工东门</span>
                </p>
                <p class="agreed-time">约定时间：{{ item.time }}</p>
              </div>
              <button class="address-copy"></button>
            </div>

            <div class="mark-item-content" v-if="item.type == 'roads'">
              <div class="icon">
                <span style="font-size: 22px"></span>
              </div>
              <div class="item-wrap">
                <p class="share-type univ">多路段共享</p>
                <p class="remarks">备注：{{ item.info }}</p>
                <p class="agreed-time">约定时间：{{ item.time }}</p>
              </div>
              <button class="address-copy"></button>
            </div>

            <div class="mark-item-content" v-if="item.type == 'algoroad'">
              <div class="icon">
                <span style="font-size: 22px"></span>
              </div>
              <div class="item-wrap">
                <p class="share-type univ">多途径点共享</p>
                <p class="remarks">备注：{{ item.info }}</p>
                <p class="agreed-time">约定时间：{{ item.time }}</p>
              </div>
              <button class="address-copy"></button>
            </div>
          </div>
          <div style="height: 60px; width: 100%"></div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/Footer.vue";

export default {
  data() {
    return {
      touch: {
        startX: 0,
        moveX: 0,
        endX: 0,
        disX: 0,
      },
      tabIndex: 0,
      cookieData: [],
      markData: [],
    };
  },
  mounted() {
    console.log(this.cookieData);
  },
  mounted() {
    let _this = this;
    let CookiesTotal = _this.getCookieName(_this.$cookies.keys());
    for (let i = 0; i < CookiesTotal.length; i++) {
      _this.cookieData.push(_this.$cookies.get(CookiesTotal[i]));
    }
    console.log(_this.cookieData);
    this.getMarkData(_this.cookieData);
  },
  methods: {
    // 根据cookie保存的id去获取数据
    getMarkData(cookieData) {
      let _this = this;
      let resData = [];
      setTimeout(() => {
        for (let i = 0; i < cookieData.length; i++) {
          let id = cookieData[i].id;

          this.$http
            .get(`/service/sharelist/${id}`, {
              id,
            })
            .then(function (oRes) {
              setTimeout(() => {
                _this.markData.push(JSON.parse(JSON.stringify(oRes.data)));
              }, 0);
            });
        }
      }, 0);
      // console.log(this.markData)
      console.log(this.markData[1]);
    },
    // 获取带有 marked 字符串的Cookies
    getCookieName(arr) {
      let res = [];
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].indexOf("mark") !== -1) res.push(arr[i]);
      }
      return res;
    },
    delCookie(cookieName, index) {
      this.$cookies.remove(cookieName);
      this.cookieData.splice(index, 1);
    },
    touchStart(ev, index) {
      ev = ev || event;
      if (ev.touches.length == 1) {
        this.touch.startX = ev.touches[0].clientX;
      }
      // 隐藏其他正在显示关闭按钮的
    },
    touchMove(ev, index) {
      ev = ev || event;
      if (ev.touches.length == 1) {
        // 滑动时距离浏览器左侧的距离
        this.touch.moveX = ev.touches[0].clientX;
        // 实时移动的距离
        this.touch.disX = this.touch.moveX - this.touch.startX;
        // console.log(this.touch.disX);

        if (
          this.touch.disX < 0 &&
          this.touch.disX > -document.body.clientWidth * 0.8
        ) {
          // console.log(this.touch.disX);
          // this.$refs.del.style.left = -60 - this.touch.disX + "px";
          const delId = `del${index}`;
          this.$refs[delId][0].style.left = this.touch.disX + "px";
        }
      }
    },
    touchEnd(ev, cookieName, index) {
      ev = ev || event;
      if (ev.changedTouches.length == 1) {
        this.touch.endX = ev.changedTouches[0].clientX;
        const diff = this.touch.startX - this.touch.endX;
        const delId = `del${index}`;
        console.log(diff);
        if (diff > document.body.clientWidth * 0.8) {
          // alert();
          // this.$refs[delId][0].style.left = -60 + "px";
          this.delCookie(cookieName, index);
          this.$refs[delId][0].style.left = 0;
        } else {
          this.$refs[delId][0].style.left = 0;
          this.$refs[delId][0].style.transition = "ease .5s";
          setTimeout(() => {
            this.$refs[delId][0].style.transition = "none";
          }, 500);
        }
      }
    },
  },
  components: {
    Footer,
  },
};
</script>

<style lang="less" scoped>
@import "../assets/less/Mark.less";
</style>